export default "__VITE_ASSET__164e677b__"